<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="true" />
    <div class="content-wrapper" v-loading="pageLoading">
      <div v-if="unConfigList.length>0"><div class="unConfig-box">{{getUnConfigItem}}</div></div>
      <div class="normal_box">
        <div class="box">
          <div class="search">
            <el-form :inline="true" :model="POlistParams" ref="searchForm" class="searchForm">
              <el-form-item class="item" prop="vendorName">
                <el-input v-model="POlistParams.vendorName" placeholder="供应商名称" size="small" clearable>
                </el-input>
              </el-form-item>
              <el-form-item class="item" prop="vendorName">
                <el-input v-model="POlistParams.vendorCode" placeholder="供应商编码" size="small" clearable>
                </el-input>
              </el-form-item>
              <el-form-item class="item-btn">
                <el-button type="danger" size="small" @click="getGameplanPRPOVender()">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="info" size="small" @click="resetList()">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
            :data="poList"
            :header-cell-style="{
            background:'#E8E8E8'}"
            :row-key="poList.poNumber"
            v-loading="tableLoading"
          >
            <el-table-column label="供应商名称" prop="vendorName" align="center" />
            <el-table-column label="信息" prop="workPhone" align="center" width="550">
              <template slot-scope="scope">
                <div v-if="scope.row.gpThemeVendorMappingDTOList&&scope.row.gpThemeVendorMappingDTOList.length>0" class="mapping-info-line-box">
                  <div class="mapping-info-line">
                      {{scope.row.gpThemeVendorMappingDTOList[0].themeChannelName}}-{{scope.row.gpThemeVendorMappingDTOList[0].themeStyleName}}-
                      <span v-if="scope.row.gpThemeVendorMappingDTOList[0].themeLevelName">{{scope.row.gpThemeVendorMappingDTOList[0].themeLevelName.split('|')[0]}}-</span>
                      {{scope.row.gpThemeVendorMappingDTOList[0].buName.split('|')[0]}}-{{scope.row.gpThemeVendorMappingDTOList[0].regionName.split('|')[0]}}
                  </div>
                  <div type="text" class="more-btn" v-if="scope.row.gpThemeVendorMappingDTOList&&scope.row.gpThemeVendorMappingDTOList.length>1" @click="showMoreDialog(scope.row)">查看更多</div>
                  <div type="text" class="more-btn" v-else></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" >
              <template slot-scope="scope">
                <div class="operation-box">
                  <el-button class="connect-btn"  type="primary" plain size="small" v-if="scope.row.gpThemeVendorMappingDTOList&&scope.row.gpThemeVendorMappingDTOList.length>0"
                     @click="handleGetGameplanPRPOMapping(scope.row.vendorCode)">
                    修改配置
                  </el-button>
                  <el-button class="connect-btn"  type="danger" plain size="small" v-else
                     @click="handleGetGameplanPRPOMapping(scope.row.vendorCode)">
                    配置可用区域
                  </el-button>
                  <!-- <el-button v-show="scope.row.gpThemeVendorMappingDTOList" class="connect-btn" slot="reference" plain size="mini" type="primary" @click="handleConfirm(scope.row)">
                   确认PO关联
                  </el-button> -->
                </div>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog
    :title="'供应商名称：'+rowInfo.vendorName||''"
      :visible.sync="showConfirmDialog" :before-close="handleDialogClose"
      width="70%" top="10vh" >
      <div v-loading="showMoreDialogLoading">
        <div class="search">
            <el-form :inline="true" :model="queryParams" ref="searchForm" class="searchForm">
              <el-form-item class="item" prop="themeChannelScope">
                <el-select v-model="queryParams.themeChannelCode" placeholder="渠道" size="small" clearable>
                  <el-option v-for="item in gpThemeChannelMap" :key="item.key" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="item">
                <el-select v-model="queryParams.themeStyleCode" placeholder="形式" size="small" clearable>
                  <el-option v-for=" (value,key) in themeStyleMap" :key="key" :label="value" :value="key">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="item" prop="themeChannelScope">
                <el-select v-model="queryParams.themeLevelCode" placeholder="级别" size="small" clearable>
                  <el-option v-for="(value,key) in themeLevelMap" :key="key" :label="value" :value="key">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item class="item" prop="themeChannelScope" v-if="userInfo.employeeLevel>=90">
                <el-select v-model="queryParams.buCode" placeholder="BU" size="small" clearable>
                  <el-option v-for="item in assignBuList" :key="item.orgCode" :label="item.orgName" :value="item.orgCode">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="item-btn">
                <el-button type="danger" size="small" @click="getGameplanPRPOList(1,10)">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="info" size="small" @click="resetForm()">重置</el-button>
              </el-form-item>
            </el-form>
        </div>
        <el-table :data="mappingDTOList" :header-cell-style="{background:'#ebebeb',color:'black' }">
          <el-table-column label="渠道" align="center" prop="themeChannelName" />
          <el-table-column label="形式" align="center" prop="themeStyleName" />
          <el-table-column label="级别" align="center" prop="themeLevelName" />
          <el-table-column label="BU" align="center">
            <template slot-scope="scope">
              {{ getName(scope.row.buName) }}
            </template>
          </el-table-column>
          <el-table-column label="销售大区" align="center">
            <template slot-scope="scope">
              {{ getName(scope.row.regionName) }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background :total="total" layout="total, prev, pager, next" :current-page="queryParams.page"
            :page-size="queryParams.pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        </div>
      </div>
    </el-dialog>

    <MappingRegionDialog ref="mappingRegionDialogRef" @handleMappingSuccess="handleMappingSuccess"/>

  </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import ContentHeader from '@/components/content-header';
import gameplanApi from "@/api/gameplan";
import MappingRegionDialog from "./components/mapping-region-dialog"
import { commonUtils } from '@/utils/common'
export default {
  components: {
    ContentHeader,
    MappingRegionDialog
  },
  computed: {
    ...mapGetters(["userInfo"]),
    ...mapState({
      gpThemeChannelMap:state=> state.base.gpThemeChannelMap,
    }),
    getUnConfigItem(){
      let length = this.unConfigList.length
      let infoList = this.unConfigList.slice(0,2)
      let otherInfo = ''
      if(length>2){
        otherInfo = `等 ${length} 项未配置`
      }else {
        otherInfo = `未配置`
      }
      return infoList.join('；')+otherInfo
    },
  },
  data(){
    return {
      themeId:'',
      total: 0,
      poList:[],
      POlistParams:{
        poNumber:'',
        vendorName:'',
        vendorCode:''
      },
      PRPOlistParams:{
        page:1,
        pageSize:10
      },
      dialogPrams:{
        page:1,
        pageSize:10,
        vendorCode:'',
      },
      queryParams: {
        page: 1,
        pageSize: 10,
        themeChannelCode: '',
        themeLevelCode:'',
        themeStyleCode:'',
        buCode:''
      },
      mappingList:[],
      mappingDTOList:[],
      showConfirmDialog:false,
      rowInfo:{},
      loading:true,
      pageLoading:false,
      showMoreDialogLoading:false,
      tableLoading:false,
      themeStyleMap:{},
      themeLevelMap:{},
      assignBuList:[],
      unConfigList:[],
      vendorCode:'',
    }
  },
  watch:{
    'queryParams.themeChannelCode' (val){
      this.getGameplanConfigStyleMap(val)
      this.queryParams.themeStyleCode = ''
      this.queryParams.themeLevelCode = ''
      this.themeStyleMap = {}
      this.themeLevelMap = {}
    },
    'queryParams.themeStyleCode' (val){
      this.getGameplanConfigLevelMap(val)
      this.queryParams.themeLevelCode = ''
      this.themeLevelMap = {}
    },
    focusChannel(){
      this.focusStyle = this.focusChannel.themeStyles&&this.focusChannel.themeStyles[0]||{}
    },
    focusLevel(nval,oval){
      if(nval&&oval){
        this.focusBU = this.focusLevel.mappingBuList&&this.focusLevel.mappingBuList[0] || {}
        this.focusRegion = this.focusBU.mappingRegionList&&this.focusBU.mappingRegionList[0] || {}
      }
    },
    focusStyle(){
        if(this.focusStyle.themeLevels&&this.focusStyle.themeLevels.length>0){
          this.focusLevel = this.focusStyle.themeLevels&&this.focusStyle.themeLevels[0] || {}
          this.focusBU = this.focusLevel.mappingBuList&&this.focusLevel.mappingBuList[0] || {}
        }else {
          this.focusLevel = null
          this.focusBU = this.focusStyle.mappingBuList&&this.focusStyle.mappingBuList[0] || {}
        }
        this.focusRegion = this.focusBU.mappingRegionList&&this.focusBU.mappingRegionList[0] || {}
    }
  },
  created() {
    this.$store.dispatch('getDictByName','gpThemeChannelMap')
    this.themeId = this.$route.query.themeId
    this.getGameplanPRPOVender();
    this.getGameplanPRPONotConfigured()
  },
  methods: {
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    async getGameplanPRPONotConfigured() {
      this.pageLoading = true
      const params = {
        themeId : this.$route.query.themeId
      }
      const { data } = await gameplanApi.getGameplanPRPONotConfigured(params);
      if (data.resultCode === "0") {
        this.unConfigList = data.resultData?.unConfigList || [];
      }
      this.pageLoading = false
    },
    async getGameplanPRPOVender() {
      this.tableLoading = true
      this.POlistParams.themeId = this.$route.query.themeId
      const { data } = await gameplanApi.getGameplanPRPOVender(this.POlistParams);
      if (data.resultCode === "0") {
        this.poList = data.resultData?.poList || [];
      }
      this.tableLoading = false
    },
    showMoreDialog(row){
      this.rowInfo = row
      this.queryParams.vendorCode = this.rowInfo.vendorCode
      this.queryParams.themeId = this.themeId
      this.getGameplanPRPOList()
      this.getGameplanConfigFull()
    },
    async getGameplanPRPOList() {
      this.showMoreDialogLoading = true
      this.showConfirmDialog = true
      this.queryParams.vendorCode = this.rowInfo.vendorCode
      this.queryParams.themeId = this.themeId
      const { data } = await gameplanApi.getGameplanPRPOList(this.queryParams);
      if (data.resultCode === "0") {
        this.mappingDTOList = data.resultData?.mappingList || [];
        this.total = data.resultData.pageInfo.totalCounts
        //this.total = data.resultData.pageInfo.totalCounts;
      }
      this.showMoreDialogLoading = false
    },
    async getGameplanConfigStyleMap() {
      let params = {
        channelCode:this.queryParams.themeChannelCode
      }
      const { data } = await gameplanApi.getGameplanConfigStyleMap(params);
      if (data.resultCode === "0") {
        // this.themeStyleMap = data.resultData?.themeStyleMap || {}
        this.themeStyleMap = Object.assign(data.resultData?.themeStyleMap||{})
      }
    },
    async getGameplanConfigLevelMap() {
      let params = {
        styleCode:this.queryParams.themeStyleCode
      }
      const { data } = await gameplanApi.getGameplanConfigLevelMap(params);
      if (data.resultCode === "0") {
        this.themeLevelMap =  data.resultData?.themeLevelMap||{}
      }
    },
    async getGameplanConfigFull() {
      const { data } = await gameplanApi.getGameplanConfigFull();
      if (data.resultCode === "0") {
        this.assignBuList =  data.resultData?.assignBuList||{}
      }
    },
    handleGetGameplanPRPOMapping(vendorCode){
      this.$refs.mappingRegionDialogRef.showInfo(this.themeId,vendorCode)
    },
    handleMappingSuccess(){
      this.getGameplanPRPOVender()
      this.getGameplanPRPONotConfigured()
    },
    resetList(){
      this.POlistParams = {
        vendorName:'',
        vendorCode:''
      }
      this.getGameplanPRPOVender();
    },
    resetForm() {
      this.queryParams=  {
        page: 1,
        pageSize: 10,
        themeChannelCode: '',
        themeLevelCode:'',
        themeStyleCode:'',
        buCode:''
      },
      this.getGameplanPRPOList()
    },
    handleConfirm(row){
      this.$confirm('是否确认关联PO（确认后将无法修改配置）？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(async() => {
        let params = {
          vendorCode:row.vendorCode,
          themeId:this.themeId,
          gpThemeVendorMappingDTOList:row.gpThemeVendorMappingDTOList
        }
        //console.log(params);
        const { data } = await gameplanApi.getGameplanPRPOConfirm(params);
        if (data.resultCode === "0") {
          this.$message.success("关联成功！")
        }
        this.getGameplanPRPOVender();
      }).catch(() => {
      });
    },
    handleDialogClose(){
      this.resetForm()
      this.showConfirmDialog = false
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getGameplanPRPOList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getGameplanPRPOList()
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  margin: 0 auto 15px;
  width:1000px;
}
::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 55vh;
}
::v-deep .el-pagination{
  text-align: center;
  margin-top: 20px;
}
::v-deep .el-checkbox{
  width: max-content;
  padding-left: 10px;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #3a3a3a !important;
}

.box{
  margin:0 10px;
}
.operation-box{
  cursor: pointer;
  color: rgb(45, 154, 255);
  // width: 220px;
  // display: flex;
  //justify-content: space-evenly;
}
.more-btn{
  min-width: 75px;
  font-size: 12px;
  color:rgb(17, 168, 255);
  cursor: pointer;
  //position: relative;
  //left: 300px;
}
.mapping-info-line-box{
  width:100%;
  display:flex;
  justify-content:space-between;
}
.mapping-info-line{
  width:450px;
  text-align:center;
  text-wrap:noWrap;
  text-overflow: ellipsis;
  overflow:hidden;
  margin:0 auto;
}

// .connect-btn{
//   position: relative;
//   left: 50px;
// }
.search {
      // margin-left: 60px;
      .searchForm {
        width: 100%;
        .item {
          width: 120px;
        }
        .item-btn {
          margin-left: 30px;
        }
      }
    }
.unConfig-box{
  display: inline-block;
  padding: 6px 10px;
  margin-bottom: 20px;
  color:white;
  border-radius: 5px;
  background-color:rgb(204, 0, 0)
}
</style>
